import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "conversation-accordion__header" };
const _hoisted_3 = ["aria-label", "onKeydown"];
import { ref, watch, nextTick, onMounted, onUnmounted } from "vue";
import RecAccordion from "@/common/components/RecAccordion.vue";
import TranscriptContent from "../components/TranscriptContent.vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { vTooltip } from "@/common/directives/tip-directive";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranscriptBlock',
    props: {
        response: {},
        excerptable: { type: Boolean },
        wrapInAccordion: { type: Boolean, default: false },
        clipboardHeader: { default: "" },
        userName: { default: "User" }
    },
    setup(__props) {
        const props = __props;
        // Setup
        const accordionTab = ref(-1);
        let timeout = null;
        watch(accordionTab, async () => {
            await nextTick();
            if (timeout)
                clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.Ramius?.highlight?.drawMarkers?.();
            }, 500);
        });
        // Listen for excerpt mode changes from JSP
        const handleExcerptModeToggle = () => {
            if (props.wrapInAccordion) {
                accordionTab.value = 0;
            }
        };
        onMounted(() => {
            window.addEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        onUnmounted(() => {
            window.removeEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        // Copy transcript functionality
        const isCopying = ref(false);
        const copyTranscriptLink = async () => {
            try {
                if (isCopying.value)
                    return;
                isCopying.value = true;
                // Use clipboard header if provided
                const metadata = props.clipboardHeader || "";
                // Build transcript content
                let transcriptContent = "";
                if (props.response.messages) {
                    for (const message of props.response.messages) {
                        const speaker = message.role === "assistant" ? "AI" : props.userName;
                        const rawText = message.rawContent || message.content || "";
                        transcriptContent += `${speaker}: ${rawText}\n\n`;
                    }
                }
                const fullContent = metadata + transcriptContent.trim();
                await navigator.clipboard.writeText(fullContent);
                // Reset button state after 2 seconds
                setTimeout(() => {
                    isCopying.value = false;
                }, 2000);
                console.log("Transcript copied to clipboard");
            }
            catch (err) {
                console.error("Failed to copy transcript:", err);
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = "Transcript content";
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                setTimeout(() => {
                    isCopying.value = false;
                }, 2000);
            }
        };
        return (_ctx, _cache) => {
            return (_ctx.response.messages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (props.wrapInAccordion)
                        ? (_openBlock(), _createBlock(RecAccordion, {
                            key: 0,
                            modelValue: accordionTab.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((accordionTab).value = $event)),
                            class: "conversation-accordion",
                            color: "var(--p-d-100)",
                            "background-color": "var(--p-d-10)",
                            "border-color": "var(--p-d-30)"
                        }, {
                            "tab-0-header": _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Conversation Transcript")), 1),
                                    (props.excerptable)
                                        ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "conversation-accordion__button",
                                            "aria-label": _ctx.$t('Copy to clipboard'),
                                            onClick: _withModifiers(copyTranscriptLink, ["stop"]),
                                            onKeydown: [
                                                _withKeys(_withModifiers(copyTranscriptLink, ["stop"]), ["enter"]),
                                                _withKeys(_withModifiers(copyTranscriptLink, ["stop"]), ["space"])
                                            ]
                                        }, [
                                            _createVNode(SvgIcon, { icon: "icon-copy" }),
                                            _createElementVNode("span", null, _toDisplayString(isCopying.value ? _ctx.$t("Copied") : _ctx.$t("Copy")), 1)
                                        ], 40, _hoisted_3)), [
                                            [
                                                _unref(vTooltip),
                                                _ctx.$t('Copy to clipboard'),
                                                void 0,
                                                { hidePoint: true }
                                            ]
                                        ])
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            "tab-0-content": _withCtx(() => [
                                _createVNode(TranscriptContent, {
                                    excerptable: _ctx.excerptable,
                                    response: _ctx.response
                                }, null, 8, ["excerptable", "response"])
                            ]),
                            _: 1
                        }, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(TranscriptContent, {
                            key: 1,
                            excerptable: _ctx.excerptable,
                            response: _ctx.response
                        }, null, 8, ["excerptable", "response"]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
